<template>
  <div v-if="isProcessing" class="sf-btn" :data-testid="containerTestId">
    <div class="sf-spinner-wrapper sf-pad-r-1 sf-inline-block">
      <div class="sf-spinner sf-spinner-primary"></div>
    </div>
    <span> {{ processingText }} ...</span>
  </div>
  <div v-else :class="uploadButtonClass" @click="handleClick">
    <span>
      <i class="fa fa-wand-magic-sparkles" />
      {{ uploadButtonText }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, onBeforeUnmount } from 'vue'

import { useDocumentUpload } from '../composables/use-document-upload'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useOCRUI } from '../store/use-ocr-ui'

defineOptions({
  name: 'AIOCRDocumentsUploader',
})

interface Props {
  ledgerId: number
  reconciliationTextId: number
  accountId: number
  aiProposal: boolean
}

const props = defineProps<Props>()
const I18n = useI18n()
const uiStore = useOCRUI()

const { isProcessing, uiState } = storeToRefs(uiStore)

const processingText = I18n.t('ai_ocr_requests.banner.processing')
const uploadButtonText = I18n.t('ai_ocr_requests.banner.upload')

const containerTestId = computed(() => {
  return `ai-ocr-documents-upload-${uiState.value}`
})

const uploadButtonClass = computed(() => {
  return props.aiProposal
    ? 'sf-btn tw-bg-violet-600 tw-border-violet-900 tw-text-white'
    : 'sf-btn sf-btn-primary'
})

onBeforeUnmount(() => {
  removeSubscription()
})

const { removeSubscription } = useDocumentUpload()

function handleClick(): void {
  window.modalCitizen.openModalPortal('input-automation-steps-modal')
}
</script>
